import { PageBody, PageHead } from '../layout';

const Error = () => {
  return (
    <>
      <PageHead title="Not Found" subtitle="The page you requested could not be located." />
      <PageBody>
        <div className="text-text-2 text-[13px]">
          Sorry, page not found or an error occurred.
        </div>
      </PageBody>
    </>
  );
};

export default Error;
